export default __webpack_public_path__ + "static/media/image2.81b51f7e.png";